module.exports = __webpack_public_path__ + "img/sec2_23.af9568b0.jpg";